import createReducer from 'utils/createReducer';

const INIT_STATE = {
  journeys: {},
  plainData: new Map(),
  loading: false,
};

const SET_DATA = 'driverJourneys/SET_DATA';
const SET_RESET_DATA = 'driverJourneys/SET_RESET_DATA';
const SET_PLAIN_DATA = 'driverJourneys/SET_PLAIN_DATA';
const SET_LOADING = 'driverJourneys/SET_LOADING';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_DATA](state, payload) {
    return {
      ...state,
      journeys: payload,
    };
  },
  [SET_PLAIN_DATA](state, { plainData }) {
    return {
      ...state,
      plainData,
    };
  },
  [SET_RESET_DATA](state) {
    return {
      ...state,
      plainData: new Map(),
      journeys: {},
    };
  },
  [SET_LOADING](state, loading) {
    return {
      ...state,
      loading,
    };
  },
});

export const setData = (journeys) => ({
  type: SET_DATA,
  payload: journeys,
});

export const setLoading = (payload) => ({
  type: SET_LOADING,
  payload,
});

export const setResetData = (payload) => ({
  type: SET_RESET_DATA,
  payload,
});

export const setPlainData = (plainData) => ({
  type: SET_PLAIN_DATA,
  payload: { plainData },
});
